import { render } from "./NewLocationModal.vue?vue&type=template&id=188d6341"
import script from "./NewLocationModal.vue?vue&type=script&lang=js"
export * from "./NewLocationModal.vue?vue&type=script&lang=js"

import "./NewLocationModal.vue?vue&type=style&index=0&id=188d6341&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__